// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const PageTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.pageTitle"
        description="Page title."
        defaultMessage="Monetization"
    />
);
PageTitle.displayName = "PageTitle";

export const TabLensPlusPayouts = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.tabLensPlusPayouts"
        description="Tab lens plus payouts."
        defaultMessage="Lens+ Payouts"
    />
);
TabLensPlusPayouts.displayName = "TabLensPlusPayouts";

export const TabTopPerformerPayouts = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.tabTopPerformerPayouts"
        description="Tab top performer payouts."
        defaultMessage="Top Performer Payouts"
    />
);
TabTopPerformerPayouts.displayName = "TabTopPerformerPayouts";

export const TabLensPlusTopCharts = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.tabLensPlusTopCharts"
        description="Tab lens plus top charts."
        defaultMessage="Lens+ Top Charts"
    />
);
TabLensPlusTopCharts.displayName = "TabLensPlusTopCharts";

export const OpensInNewTab = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.opensInNewTab"
        description="Opens in new tab."
        defaultMessage="(opens in a new tab)"
    />
);
OpensInNewTab.displayName = "OpensInNewTab";
